<template>
  <div class="container" v-if="forms.length > 0">
    <loading
      :active.sync="loading"
      :is-full-page="fullpage"
      :height="26"
      :width="26"
    ></loading>
    <div
      class="question"
      v-for="({
        d_form_answer_type_desc,
        d_question,
        value,
        answers,
        d_form_question_id,
      },
      index) in forms"
      :key="index"
    >
      <div v-if="d_form_answer_type_desc === 'Dropdown'" class="row">
        <label class="title">{{ index + 1 }}.{{ d_question }}</label>
        <div class="option">
          <select
            class="select"
            v-model="forms[index].value"
            :disabled="status === 2"
            @change="(e) => selectDidChange(e, index)"
          >
            <option value="default">请选择</option>
            <option
              v-for="(answer, aIndex) in answers"
              :key="aIndex"
              :value="answer.d_answer_id"
              >{{ answer.d_answer }}</option
            >
          </select>
        </div>
      </div>
      <div v-if="d_form_answer_type_desc === 'Text'" class="row">
        <label class="title">{{ index + 1 }}.{{ d_question }}</label>
        <div class="option">
          <input v-model="forms[index].value" :disabled="status === 2" />
        </div>
      </div>
      <div v-if="d_form_answer_type_desc === 'DateTimePicker'" class="row">
        <label class="title">{{ index + 1 }}.{{ d_question }}</label>
        <div class="option">
          <Datepicker
            class="date-picker"
            input-class="date-input"
            v-model="forms[index].value"
            :language="pickLag"
            format="yyyy-MM-dd"
            :name="d_question"
            :disabled="status === 2"
          />
        </div>
      </div>
      <div v-if="d_form_answer_type_desc === 'Checkboxes'" class="row">
        <label class="title">{{ index + 1 }}.{{ d_question }}</label>
        <div class="option">
          <p
            v-for="(answer, aIndex) in answers"
            :key="aIndex"
            class="checkbox-row"
          >
            <input
              v-model="forms[index].value"
              :id="answer.d_answer_id"
              type="checkbox"
              :value="answer.d_answer_id"
              :disabled="status === 2"
            /><label v-bind:for="answer.d_answer_id">{{
              answer.d_answer
            }}</label>
          </p>
        </div>
      </div>
    </div>
    <button
      v-if="status !== 2"
      :loading="loading"
      class="submit-btn"
      @click="onSubmit(2)"
    >
      提交
    </button>

    <button
      v-if="status !== 2"
      :loading="loading"
      class="submit-btn"
      @click="onSubmit(1)"
    >
      保存
    </button>
  </div>
</template>

<script>
import queryString from 'query-string';
import Datepicker from 'vuejs-datepicker';
import { zh } from 'vuejs-datepicker/dist/locale';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Form',
  components: {
    Datepicker,
    Loading,
  },
  data() {
    return {
      forms: [],
      pickLag: zh,
      loading: false,
      fullpage: true,
      status: 0,
    };
  },
  mounted() {
    const searchString = location.hash.split('?')[1];
    const searchParams = queryString.parse(searchString);
    const { formId, token, status } = searchParams;
    this.appData = searchParams;
    this.status = Number(status);
    if (Number(status) === 0) {
      const requestURL = `${this.apiBaseUrl}DreamIT_TherapyAuth/form_questions_by_assignment_id`;

      this.axios({
        url: requestURL,
        data: {
          FormAssignmentID: formId,
          Language: 'ch',
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        method: 'POST',
      })
        .then((res) => {
          this.forms = res.data.map((r) => {
            let value;
            if (r.d_form_answer_type_desc === 'Text') {
              value = undefined;
            } else if (r.d_form_answer_type_desc === 'Checkboxes') {
              value = [];
            } else if (r.d_form_answer_type_desc === 'Dropdown') {
              value = undefined;
            } else if (r.d_form_answer_type_desc === 'DateTimePicker') {
              value = undefined;
            }
            return {
              ...r,
              value,
            };
          });
        })
        .catch((err) => console.log('-------', err));
    } else if (Number(status) === 2) {
      this.axios({
        url:
          this.apiBaseUrl + 'DreamIT_TherapyAuth/form_results_by_assignment_id',
        data: {
          FormAssignmentID: formId,
          Language: 'ch',
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        method: 'POST',
      })
        .then((response) => {
          this.forms = response.data.map((f) => {
            let value;
            if (f.d_form_answer_type_desc === 'Text') {
              value = f.answers[0].d_submitted_value;
            } else if (f.d_form_answer_type_desc === 'Checkboxes') {
              value = f.answers.map((a) => a.d_answer_id);
            } else if (f.d_form_answer_type_desc === 'Dropdown') {
              value = f.value;
            } else if (f.d_form_answer_type_desc === 'DateTimePicker') {
              value = new Date(f.answers[0].d_submitted_value);
            }
            return {
              ...f,
              value,
            };
          });
          console.log('-------', this.forms);
        })
        .catch((e) => {
          console.log(e);
        });
    } else if (Number(status) === 1) {
      this.axios({
        url:
          this.apiBaseUrl +
          'DreamIT_TherapyAuth/form_saved_results_by_assignment_id',
        data: {
          FormAssignmentID: formId,
          Language: 'ch',
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        method: 'POST',
      })
        .then((res) => {
          this.forms = res.data.map((f) => {
            let value;
            if (f.d_form_answer_type_desc === 'Text') {
              value = f.answers[0].d_submitted_value;
            } else if (f.d_form_answer_type_desc === 'Checkboxes') {
              const submittedValues = f.answers.filter(
                (a) => a.d_submitted_value
              );
              value = submittedValues.map((s) => s.d_submitted_value);
            } else if (f.d_form_answer_type_desc === 'Dropdown') {
              const foundValue = f.answers.find((a) => a.d_submitted_value);
              if (foundValue) {
                value = foundValue.d_submitted_value;
              }
            } else if (f.d_form_answer_type_desc === 'DateTimePicker') {
              value = f.answers[0].d_submitted_value
                ? new Date(f.answers[0].d_submitted_value)
                : undefined;
            }
            return {
              ...f,
              value,
            };
          });
        })
        .catch((err) => console.log('------err', err));
    }
  },
  methods: {
    selectDidChange(e, index) {
      if (e.target.value !== 'default') {
        const forms = [...this.forms];
        forms[index].value = Number(e.target.value);
        this.forms = forms;
      } else {
        const forms = [...this.forms];
        forms[index].value = undefined;
        this.forms = forms;
      }
    },
    onSubmit(formStatus) {
      if (!this.isSubmitting) {
        this.isSubmitting = true;
        let filledAllQuestions = true;
        let hasAnswers = false;
        if (formStatus === 2) {
          this.forms.forEach((f) => {
            const answer = f.value;
            if (Array.isArray(answer) && answer.length === 0) {
              filledAllQuestions = false;
              return;
            } else if (
              !answer ||
              (typeof myVar === 'string' && answer.length === 0)
            ) {
              filledAllQuestions = false;
              return;
            }
          });
        } else {
          this.forms.forEach((f) => {
            const answer = f.value;
            if (Array.isArray(answer) && answer.length > 0) {
              hasAnswers = true;
              return;
            } else if (
              answer &&
              typeof myVar === 'string' &&
              answer.length > 0
            ) {
              hasAnswers = true;
              return;
            } else if (answer) {
              hasAnswers = true;
              return;
            }
          });
        }

        if (formStatus === 2) {
          if (!filledAllQuestions) {
            this.isSubmitting = false;
            this.$alert('请填写所有问题', '', '', {
              confirmButtonText: '确定',
            });
          } else {
            this.uploadAnswer(formStatus);
          }
        } else {
          if (!hasAnswers) {
            this.isSubmitting = false;
            this.$alert('没有回答需要保存', '', '', {
              confirmButtonText: '确定',
            });
          } else {
            this.uploadAnswer(formStatus);
          }
        }
      }
    },
    uploadAnswer(formStatus) {
      this.loading = true;
      const answers = this.forms.map((f) => {
        return {
          questionId: f.d_form_question_id,
          value: Array.isArray(f.value)
            ? JSON.parse(JSON.stringify(f.value))
            : f.value instanceof Date
            ? `${f.value.getFullYear()}/${f.value.getMonth() +
                1}/${f.value.getDate()}`
            : f.value,
        };
      });
      const finalAnswers = [];
      answers.forEach((a) => {
        if (Array.isArray(a.value)) {
          a.value.forEach((e) => {
            finalAnswers.push({
              QuestionID: a.questionId,
              Answer: e,
              AnswerOther: '',
            });
          });
        } else {
          finalAnswers.push({
            QuestionID: a.questionId,
            Answer: a.value || '',
            AnswerOther: '',
          });
        }
      });
      const { token, formId, userId } = this.appData;

      console.log('------', {
        FormStatus: formStatus,
        MemberID: userId,
        FormAssignmentID: formId,
        Language: 'ch',
        Answers: finalAnswers,
      });
      this.axios({
        url: this.apiBaseUrl + 'DreamIT_TherapyAuth/form_submit3',
        data: {
          FormStatus: formStatus,
          MemberID: userId,
          FormAssignmentID: formId,
          Language: 'ch',
          Answers: finalAnswers,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        method: 'POST',
      })
        .then(() => {
          this.loading = false;
          this.isSubmitting = false;
          if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                func: 'submitSuccess',
                formId,
                status: formStatus,
              })
            );
          }
        })
        .catch(() => {
          this.loading = false;
          this.isSubmitting = false;
        });
    },
  },
};
</script>

<style scoped>
.container {
  padding: 15px;
  background-color: white;
  box-sizing: border-box;
}

.row {
  display: flex;
  flex-direction: column;
}

.row .title {
  text-align: justify;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
}

.row .option {
  text-align: justify;
  box-sizing: border-box;
}

.question {
  margin: 10px 0;
}

select {
  width: 100%;
  height: 30px;
  -webkit-appearance: none;
  padding: 0 10px;
  border-radius: 5px;
  outline-color: #49afad;
  color: #333;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-appearance: none;
}

select[disabled] {
  border: 1px solid #999;
}

input {
  width: 100%;
  height: 30px;
  padding: 0 10px;
  border-radius: 5px;
  outline-color: #49afad;
  color: #333;
  border: 1px solid #333;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 16px;
}

input[disabled] {
  border: 1px solid #999;
}

.submit-btn {
  width: 60%;
  height: 38px;
  border: none;
  margin-top: 10px;
  margin-bottom: 20px;
  background-color: #49afad;
  color: white;
  border-radius: 20px;
  font-size: 16px;
  color: #fff;
}

.submit-btn:active {
  outline: none;
  border: none;
}

.submit-btn:focus {
  outline: 0;
}

.checkbox-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.checkbox-row input {
  width: 16px;
  height: 16px;
}

.checkbox-row label {
  font-size: 14px;
}

.date-picker >>> .date-input {
  width: 100%;
  height: 30px;
  padding: 0 10px;
  outline-color: #49afad;
}
</style>
